<template>
    <div>
        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('user_register_mode') }}
            </v-col>
            <v-col cols="12" md="6" align="left">
                <v-select
                    :value="user_register_mode"
                    @change="(val) => onchange('user_register_mode',val)"
                    :hint="`${user_register_mode.desc}`"
                    :items="user_register_mode_items"
                    item-text="name"
                    item-value="val"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

                <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('staff_register_mode') }}
            </v-col>
            <v-col cols="12" md="6" align="left">
                <v-select
                    :value="staff_register_mode"
                    @change="(val) => onchange('staff_register_mode',val)"
                    :hint="`${staff_register_mode.desc}`"
                    :items="staff_register_mode_items"
                    item-text="name"
                    item-value="val"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                    :disabled="disabled"
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="2" align="left" class="pt-6 subtitle-2">
                <b>{{ $t('register_form') }}</b>
            </v-col>
            <v-col cols="12" md="10" align="left">
                <v-btn v-if="!disabled" tile color="success" @click="addNewFormTag()">
                    <v-icon left>mdi-plus</v-icon>{{ $t('form_add') }}
                </v-btn>
            </v-col>
        </v-row>

        <v-simple-table fixed-header align="left" >
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">{{ $t('form_label') }}</th>
                <th class="text-left">{{ $t('form_required') }}</th>
                <th class="text-left"></th>
                </tr>
            </thead>
            <tbody >
                <tr v-for="(item,i) in user_register_form" :key="item.form_tag"> 
                    <td class="pt-4">
                        <v-select
                            v-model="item.form_tag"
                            :items="getFormTagItems(item.form_tag)"
                            @change="formChange"
                            item-text="name"
                            item-value="val"
                            outlined
                            dense
                            :disabled="disabled"
                        ></v-select>
                    </td>
                    <td class="pt-4">
                        <v-select
                            v-model="item.is_required"
                            :items="is_required_items"
                            @change="formChange"
                            item-text="name"
                            item-value="val"
                            outlined
                            dense
                            :disabled="disabled"
                        ></v-select>
                    </td>
                    <td>
                        <v-btn v-if="!disabled" tile icon @click="delFormTag(i)">
                            <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
            </template>
        </v-simple-table>

    </div>
</template>

<script>
  export default {
    props: ['user_register_mode','user_register_mode_items','staff_register_mode','staff_register_mode_items','user_register_form','onchange','disabled'],
    data () {
        return {
            form_tag_items : [
                {name:this.$i18n.t('form_tag_name'),val:"name"}
                ,{name:this.$i18n.t('form_tag_citizen_id'),val:"citizen_id"}
                ,{name:this.$i18n.t('form_tag_mobile_phone'),val:"mobile_phone"}
                ,{name:this.$i18n.t('form_tag_email'),val:"email"}
                ,{name:this.$i18n.t('form_tag_hn'),val:"hn"}
                ,{name:this.$i18n.t('form_tag_blood'),val:"blood"}
                ,{name:this.$i18n.t('form_tag_weight'),val:"weight"}
                ,{name:this.$i18n.t('form_tag_heigth'),val:"heigth"}
                ,{name:this.$i18n.t('form_tag_kubota_car_type'),val:"kubota_car_type"}
                ,{name:this.$i18n.t('form_tag_kubota_dealer_last'),val:"kubota_dealer_last"}
                ,{name:this.$i18n.t('form_tag_car_license_plate'),val:"car_license_plate"}
                ,{name:this.$i18n.t('form_tag_drug_allergy'),val:"drug_allergy"}
                ,{name:this.$i18n.t('form_tag_congenital_disease'),val:"congenital_disease"}
                ,{name:this.$i18n.t('form_tag_nickname'),val:"nickname"}
                ,{name:this.$i18n.t('form_tag_birthdate'),val:"birthdate"}
                ,{name:this.$i18n.t('form_tag_passport'),val:"passport"}
                ,{name:this.$i18n.t('form_tag_nationality'),val:"nationality"}
            ],
            is_required_items : [
                {name:this.$i18n.t('form_is_required_yes'),val:1}
                ,{name:this.$i18n.t('form_is_required_no'),val:0}
                ,{name:'ซ่อนไม่ให้กรอกเอง',val:2}
            ]
        }
    },
    methods : {
      getFormTagItems : function(form_tag) {
          return this.form_tag_items.filter(t=>{
              return !this.user_register_form.map(f=>f.form_tag).includes(t.val) || t.val==form_tag
          })
      },
      addNewFormTag : function() {
        this.user_register_form.push({
                form_tag:this.getFormTagItems("")[0].val
                ,is_required:1
            }
        )
        this.formChange()
      },
      delFormTag(index){
        this.user_register_form.splice(index,1)
        this.formChange()
      },
      formChange(){
        this.onchange('user_register_form',this.user_register_form)
      }
    }
  }
</script>